import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import Modal from 'shared/components/Modal';
import modalStyles from 'shared/components/modalStyles';
import messages, { FormattedMessage, withValues } from 'shared/messages/messages';
import config from 'shared/config/config';

import {
  sendEmail,
  setEmail
} from 'app/actions/kioskActions';

import {
  formatGuestName
} from 'app/utils/Utils';

const styles = () => ({
  button: {
    textAlign: 'center',
    padding: '0.3rem 1rem',
    fontSize: '1rem',
    fontWeight: 600,
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    border: '1px solid #dcdcdc',
    borderRadius: '3px',
    boxShadow: '0 0 2px #dcdcdc',
    color: '#2b8eb0',
    fontFamily: config.root_font_family
  },
  inputGroup: {
    padding: '0.3rem 0'
  },
  label: {
    float: 'left',
    fontWeight: 600,
    fontFamily: config.root_font_family
  },
  input: {
    width: '100%',
    fontSize: '1.1rem',
    padding: '0.7655rem',
    borderRadius: '5px',
    border: '1px solid #aaa',
    fontFamily: config.root_font_family
  },
  text: {
    float: 'left',
    textAlign: 'left',
    width: '100%',
    fontFamily: config.root_font_family
  },
  ...modalStyles()
});

class RoomDialog extends React.Component {
  constructor(props) {
    super(props);

    this.emailInput = createRef();

    this.state = {
      slide: 1,
      selectedGuest: null
    }
  }

  selectGuest(guest) {
    this.setState({
      selectedGuest: guest,
      slide: 2
    });
  }

  back() {
    this.setState({
      selectedGuest: null,
      slide: 1
    });
  }

  sendLink() {
    const { sendEmail } = this.props;

    let guest = this.state.selectedGuest;
    let email = this.emailInput.current.value;

    sendEmail(guest.id, email);

    this.setState({
      slide: 3,
      sentEmail: email
    });
  }

  renderGuestsSlide(style) {
    const { classes, guests } = this.props;

    let guestButtons = [];
    if (guests) {
      for (let guest of guests) {
        let name = formatGuestName(guest);

        guestButtons.push((
          <button className={classes.button} style={{float: 'left', width: '100%', marginBottom: '0.5rem'}} onClick={() => this.selectGuest(guest)}>
            {name}
          </button>
        ));
      }
    }

    return (
      <div className={classes.modalSlide} style={style}>
        {guestButtons}
      </div>
    );
  }

  renderGuestSlide(style) {
    const { classes } = this.props;

    let guest = this.state.selectedGuest;
    if (!guest) {
      return null;
    }

    let name = formatGuestName(guest);

    return (
      <div className={classes.modalSlide} style={style}>
        <p className={classes.text}>{name}</p>
        <div className={classes.inputGroup}>
          <label className={classes.label} style={{marginBottom: '0.2rem'}} for="email">
            <FormattedMessage {...messages.form_label_email_address} />
          </label>
          <input ref={this.emailInput} className={classes.input} type="email" name="email" defaultValue={guest.email} style={{borderColor: '#aaa'}} />
        </div>
	<div className={classes.modalButtons} style={{marginTop: '1rem', width: '100%'}}>
	  <button className={classes.modalButtonWhite} onClick={this.back.bind(this)}>
            <FormattedMessage {...messages.button_back} />
	  </button>
	  <button className={classes.modalButton} onClick={this.sendLink.bind(this)}>
            <FormattedMessage {...messages.button_send_link} />
	  </button>
	</div>
      </div>
    );
  }

  renderLinkSentSlide(style) {
    const { classes } = this.props;
    let email = this.state.sentEmail;

    return (
      <div className={classes.modalSlide} style={style}>
        <p style={{float: 'left', textAlign: 'left', width: '100%'}}>
          <FormattedMessage {...withValues(messages.kiosk_room_dialog_instructions_link_sent, { email })} />
        </p>
	<div className={classes.modalButtons} style={{marginTop: '1rem', width: '100%'}}>
	  <button className={classes.modalButtonWhite} onClick={this.back.bind(this)}>
            <FormattedMessage {...messages.button_back} />
	  </button>
	  <button className={classes.modalButton} onClick={this.props.close.bind(this)}>
            <FormattedMessage {...messages.button_done} />
	  </button>
	</div>
      </div>
    );
  }

  render() {
    const { classes, user, guests, visits, rooms } = this.props;

    if (!user) {
      return null;
    }

    let stageHeight;
    if (guests) {
      let rem = (guests.length * 3) + 6;
      if (rem < 12) {
        rem = 12;
      }

      stageHeight = `${rem}rem`;
    }

    let slide1Style = {visibility: 'hidden'};
    let slide2Style = {visibility: 'hidden'};
    let slide3Style = {visibility: 'hidden'};

    var sliderShift;
    switch (this.state.slide) {
      case 2:
	slide2Style.visibility = 'visible';
        sliderShift = '-22rem';
	break;

      case 3:
	slide3Style.visibility = 'visible';
        sliderShift = '-44rem';
	break;

      default:
	slide1Style.visibility = 'visible';
        sliderShift = 0;
    }

    let slide1 = this.renderGuestsSlide(slide1Style);
    let slide2 = this.renderGuestSlide(slide2Style);
    let slide3 = this.renderLinkSentSlide(slide3Style);

    let header;
    if (visits.allIds.length > 1) {
      header = withValues(messages.kiosk_room_dialog_header_multiple, { rooms });
    } else {
      header = withValues(messages.kiosk_room_dialog_header, { room: user.room });
    }

    return (
      <Modal disableScrollbar={true}
        isOpen={this.props.isOpen}
        close={this.props.close.bind(this)}>
        <div className={classes.modalOverlay} onClick={this.props.close.bind(this)}></div>
        <div className={classes.modal}>
          <CloseIcon className={classes.modalCloseIcon} onClick={this.props.close.bind(this)} />
          <div className={classes.modalHeader}>
            <span style={{fontWeight: 600}}>
              <FormattedMessage {...header} />
            </span>
          </div>
          <hr />
          <div className={classes.modalStage} style={{height: stageHeight}}>
            <div className={classes.modalSlider} style={{marginLeft: sliderShift}}>
              {slide1}
              {slide2}
              {slide3}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.kioskReducer.user,
  guests: state.kioskReducer.guests,
  visits: state.kioskReducer.visits,
  rooms: state.kioskReducer.rooms
});

export default connect(mapStateToProps, { sendEmail, setEmail })(withStyles(styles)(RoomDialog));
